import * as React from "react";
import cx from "classnames";
import { QesIcon } from "./icons/QESIcon";

interface PageHeaderProps {
  children?: React.ReactNode;
  iconName?: string;
  title: string;
  titleBadge?: React.ReactNode;
  disableHR?: boolean;
}

export default class PageHeader extends React.Component<PageHeaderProps> {
  public static readonly displayName = "PageHeader";

  public isComponent(child: React.ReactNode, displayName: string): boolean {
    const component = child as React.ReactElement;
    const type = component && component.type && component.type as React.ComponentClass;
    return type && type.displayName === displayName;
  }

  public render() {
    const children = React.Children.toArray(this.props.children);

    // Extract the left and right portions, if there are any.
    const left = children.filter((c) => this.isComponent(c, "PageHeaderLeft"));
    const right = children.filter((c) => this.isComponent(c, "PageHeaderRight"));

    // Create the icon component if we need to.
    // const icon = this.props.iconName ? <i className={`fa ${this.props.iconName} pr10`} /> : null;
    const icon = this.props.iconName ? <QesIcon iconName={this.props.iconName} className="me-2 pb-1" isDecorative={true} /> : null;

    return (
      <>
        <header className="page-title-bar">
          <div className="d-flex flex-column w-100">
            <div className={cx("d-flex", "flex-row", "align-items-center", "w-100", { "page-title-row--with-badge": !!this.props.titleBadge })}>
              <h1 className="page-title">
                <span className="me-1">
                  {icon}{this.props.title}
                </span>
              </h1>
              {this.props.titleBadge && (
                <span className="page-title-badge me-2">
                  {this.props.titleBadge}
                </span>
              )}
              {left}
              <div className="ms-auto">
                {right}
              </div>
            </div>
          </div>
          {(!this.props.disableHR || null) && (<hr className="mtb0" />)}
        </header>
      </>
    );
  }
}
